<template>
  <div class="mt-1">
    <div class="schedint-main-heads">
      {{ label }}
      <span v-if="mandatory" class="asterik">*</span>
    </div>
    <div
      ref="customSelectSearch"
      tabindex="0"
      @focusout="closeDropdownOnFocusOut"
      class="d-flex align-items-center w-100 mt-2"
    >
      <div
        :class="showError ? 'error' : ''"
        class="
          w-100
          schedint-moi
          d-flex
          align-items-center
          justify-content-between
          position-relative
          pointer
        "
        @click="
          (showDropdown = !showDropdown),
            !showDropdown
              ? ((searchQuery = ''), $emit('search-data', searchQuery))
              : ''
        "
      >
        <span
          :class="
            Object.keys(selectedValue) != 0
              ? 'inputPlaceholder-font'
              : 'input-empty-placeholder'
          "
        >
          {{
            Object.keys(selectedValue).length == 0
              ? "Select"
              : selectedValue.username
          }}
        </span>
        <div>
          <img
            v-if="!showDropdown"
            src="../../assets/cvsearch/cv-downarrow.svg"
            alt=""
          />
          <img
            v-else
            class="pointer"
            src="../../assets/cvsearch/cv-uparrow.svg"
            alt=""
          />
        </div>
        <div
          @click.stop
          v-if="showDropdown"
          style="top: 38px; z-index: 2"
          class="w-100 kanban-more-option-card p-1"
        >
          <div class="relativeclass w-100 teams-innerInputField">
            <img
              class="teams-setImage"
              src="../../assets/img/search-bar-icon.svg"
              alt
            />

            <b-form-input
              type="search"
              v-model="searchQuery"
              @update="$emit('search-data', searchQuery)"
              debounce="500"
              placeholder="Search"
              class="search-input"
            ></b-form-input>
          </div>
          <div class="w-100 mt-1 single-select-search-inner">
            <div
              class="kanban-more-option-card-input"
              v-for="opsHead in opsHeadList"
              :key="opsHead.userID"
              :class="
                selectedValue.userID == opsHead.userID
                  ? 'kanban-approver-dd-active'
                  : 'kanban-approver-dd-inactive'
              "
              @click.stop="selOpsHead(opsHead)"
            >
              {{ opsHead.username }}
            </div>
          </div>
          <div
            class="kanban-more-option-card-input text-center w-100"
            v-if="
              opsHeadList.length == 0 &&
              searchQuery != null &&
              searchQuery != ''
            "
          >
            No Matching results found for
            <strong>"{{ searchQuery }}"</strong>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showError" class="errortxt mt-1">Required</div>
  </div>
</template>

<script>
export default {
  name: "SearchSingleSelect",
  props: {
    label: String,
    mandatory: Boolean,
    showError: Boolean,
    opsHeadList: Array,
  },
  data() {
    return {
      selectedValue: {},
      showDropdown: false,
      searchQuery: null,
    };
  },
  created() {
    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdownOnClickOutside);
  },
  methods: {
    selOpsHead(opsHead) {
      this.selectedValue = opsHead;
      this.$emit("select-value", this.selectedValue);
      this.showDropdown = false;
      this.searchQuery = "";
      this.$emit("search-data", this.searchQuery);
      this.$forceUpdate();
    },
    closeDropdownOnFocusOut(event) {
      // Check if the focus is outside the custom select component
      if (!this.$refs.customSelectSearch.contains(event.relatedTarget)) {
        this.showDropdown = false; // Close the dropdown
      }
    },
  },
};
</script>

<style scoped>
.single-select-search-inner {
  max-height: 127px;
  overflow: auto;
  border-radius: 10px;
}
</style>
